const BASE_URL = "https://api.automa.id/api/incident";

export const STORING_TICKET_LIST = BASE_URL + "/storing-ticket/list";
export const STORING_TICKET_INPUT = BASE_URL + "/storing-ticket/input";
export const STORING_TICKET_EDIT = BASE_URL + "/storing-ticket/edit";
export const STORING_TICKET_DELETE = BASE_URL + "/storing-ticket/delete";